import { useEffect } from "react";
import PropTypes from "prop-types";
import { SideNav } from "./side-nav";
import { MobileNav } from "./mobile-nav";
import useFeatureMenuStore from "@stores/admin/useFeatureMenuStore";

/**
 * The admin feature menu (side/mobile nav), isolated into its own component so
 * that refreshing it re-renders ONLY the menu — not AdminLayout, the page, or
 * the routes. It reads the nav-only feature store via a selector (not the broad
 * AuthContext), so a feature toggle updates just this subtree.
 */
export const AdminNav = ({ lgUp, mobileNav }) => {
  const sections = useFeatureMenuStore((state) => state.sections);
  const loaded = useFeatureMenuStore((state) => state.loaded);
  const load = useFeatureMenuStore((state) => state.load);

  useEffect(() => {
    load();
  }, [load]);

  // Show skeleton rows until the first fetch settles, so the sidebar is never
  // just blank while loading. `loaded` flips true once and stays true (toggles
  // keep it set), so the skeleton only appears on the initial load.
  const loading = !loaded;

  if (lgUp) {
    return <SideNav sections={sections} loading={loading} />;
  }

  return (
    <MobileNav
      onClose={mobileNav.handleClose}
      open={mobileNav.open}
      sections={sections}
      loading={loading}
    />
  );
};

AdminNav.propTypes = {
  lgUp: PropTypes.bool,
  mobileNav: PropTypes.shape({
    handleClose: PropTypes.func,
    open: PropTypes.bool,
  }).isRequired,
};
